<template>
  <div class="profession">
    <div class="member-list">
      <span class="title">{{ $t('profile.company') }}</span>
      <div class="sub-list">
        <el-input
          v-model="personal.company"
          :placeholder="$t('profile.companyPlaceholder')"
        />
      </div>
    </div>
    <div class="member-list">
      <span class="title">{{ $t('profile.position') }}</span>
      <div class="sub-list">
        <el-input
          v-model="personal.position"
          :placeholder="$t('profile.positionPlaceholder')"
        />
      </div>
    </div>
    <div class="member-list">
      <span class="title">{{ $t('profile.education') }}</span>
      <div class="select">
        <el-select
          v-model="educateLevel"
          @change="educateChoice"
          :placeholder="$t('profile.educationPlaceholder')"
        >
          <el-option
            v-for="item in options"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          >
          </el-option>
        </el-select>
        <input type="checkbox" class="test" v-model="personal.postEducation" />
        <span style="margin-left: 12px">{{ $t('profile.postGraduate') }}</span>
      </div>
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch, computed } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  props: {
    userInfoList: {
      type: Object,
      default: () => ({}),
    },
  },
  setup(props) {
    const { t } = useI18n();
    const educateLevel = ref('');
    const options = [
      {
        value: t('educationLevel.highSchool'),
        label: t('educationLevel.highSchool'),
      },
      {
        value: t('educationLevel.juniorCollege'),
        label: t('educationLevel.juniorCollege'),
      },
      {
        value: t('educationLevel.underGraduate'),
        label: t('educationLevel.underGraduate'),
      },
      {
        value: t('educationLevel.graduate'),
        label: t('educationLevel.graduate'),
      },
      {
        value: t('educationLevel.doctor'),
        label: t('educationLevel.doctor'),
      },
    ];

    const personal = computed(() => props.userInfoList);

    watch(personal.value.postEducation, () => {
      personal.value.postEducation = !personal.value.postEducation;
    });

    const educateChoice = () => {
      if (educateLevel.value === t('educationLevel.highSchool')) {
        personal.value.education = 0;
      } else if (educateLevel.value === t('educationLevel.juniorCollege')) {
        personal.value.education = 1;
      } else if (educateLevel.value === t('educationLevel.underGraduate')) {
        personal.value.education = 2;
      } else if (educateLevel.value === t('educationLevel.graduate')) {
        personal.value.education = 3;
      } else if (educateLevel.value === t('educationLevel.doctor')) {
        personal.value.education = 4;
      }
    };

    onMounted(() => {
      switch (personal.value.education) {
        case 0:
          educateLevel.value = t('educationLevel.highSchool');
          break;
        case 1:
          educateLevel.value = t('educationLevel.juniorCollege');
          break;
        case 2:
          educateLevel.value = t('educationLevel.underGraduate');
          break;
        case 3:
          educateLevel.value = t('educationLevel.graduate');
          break;
        case 4:
          educateLevel.value = t('educationLevel.doctor');
          break;
        default:
          educateLevel.value = '';
      }
    });

    return { educateLevel, options, educateChoice, personal };
  },
});
</script>
<style lang="less" scoped>
.profession {
  text-align: center;
  margin-top: 30px;
  .member-list {
    display: flex;
    flex-flow: column;
    margin-top: 40px;
    .title {
      font-size: 18px;
      margin-left: 35px;
      margin-bottom: 5px;
      margin-right: auto;
    }
    .select {
      margin-left: -20px;
    }
    span {
      font-size: 18px;
      margin-right: auto;
      display: inline-block;
      height: 45px;
      line-height: 45px;
    }
    .sub-list {
      margin: 0px auto 0px 20px;
    }
    /deep/.sub-list .el-input {
      width: 668px;
      margin-left: 15px;
    }
    /deep/.select {
      margin-right: auto;
      margin-left: 35px;
      .el-input {
        width: 489px;
      }
    }

    input[type='checkbox'] {
      cursor: pointer;
      width: 20px;
      height: 20px;
      font-size: 12px;
      border-radius: 5px;
      margin-left: 40px;
      vertical-align: middle;
    }

    input[type='checkbox']:checked::after {
      top: 0;
      display: inline-flex;
      justify-content: center;
      align-items: center;
      width: 20px;
      height: 20px;
      content: '✓';
      color: #fff;
      font-size: 12px;
      font-weight: 700;
      background-color: #0ca1bd;
      border-radius: 5px;
    }
  }
}
</style>

